import { Link } from "react-router-dom"
import ImageBox from "../../../components/image-box"
import HeaderWrapperMobile from "./header-wrapper-mobile"

const LOGO_SRC = "/images/toicos-logo-a.png"

const CubiqHeaderMobile = ({ title = "큐빅 미터스", position = "sticky" }) => {
  return (
    <HeaderWrapperMobile position={position}>
      <Link to={"/select"} className="flex gap-2 justify-center items-center mr-auto">
        <ImageBox className={"w-6 h-6"} src={LOGO_SRC} />
        <h1 className="text-lg font-bold text-center whitespace-pre">{title}</h1>
      </Link>
    </HeaderWrapperMobile>
  )
}

export default CubiqHeaderMobile
